import React from "react";
import SEO from "../components/SEO/SEO";
import { Box } from "@mui/material";
import Paragraph from "../components/paragraph/Paragraph";
import { useSigilContext } from "../context/sigilContext";

const About = () => {
  const { i18n } = useSigilContext();
  const translate = i18n.about;

  return (
    <>
      <SEO
        title="Acerca de | Magia del Caos"
        description="Conoce más sobre el proyecto Magia del Caos y el desarrollador detrás de esta herramienta."
        name="Magia del Caos"
        type="article"
      />
      <Box>
        <h1>{translate.title}</h1>
        <Paragraph>
          {translate.description}
          <a
            href={`mailto:mysticcodelab@gmail.com?subject=${translate.suggestions}`}
            style={{ color: "#007bff", textDecoration: "none", marginLeft: "5px" }}
          >
            mysticcodelab@gmail.com
          </a>.
        </Paragraph>
        <Paragraph>
          {translate.userInfo}
        </Paragraph>
        
        <h2 style={{ marginTop: '40px', color: '#90caf9' }}>{translate.historyTitle}</h2>
        <Paragraph>
          {translate.historyText}
        </Paragraph>
      </Box>
    </>
  );
}

export default About;